export default __webpack_public_path__ + "maps-examples-live-data-thumbnail-480-f1c2eedf7aa1832bb7fa5970fbe63849.png";